// Custom MazUI theme aligned with Enginio brand colors.
// Colors are in HSL format without hsl() wrapper: "H S% L%"
//
// Brand references (_colors.scss):
//   $brand-yellow: #ea7801  → HSL 30 99% 46%
//   $body-bg:      #fff     → HSL 0 0% 100%
//   $body-color:   #222     → HSL 0 0% 13%
//   $silver-grey:  #ccc     → HSL 0 0% 80%

import type { ThemePreset } from '@maz-ui/themes';

export const enginioMazTheme: ThemePreset = {
  name: 'enginio',
  foundation: {
    'base-font-size': '14px',
    'font-family': 'CircularXXWeb-Regular, sans-serif',
    radius: '0.7rem',
    'border-width': '1px',
  },
  colors: {
    light: {
      background: '0 0% 100%',
      foreground: '0 0% 13%',
      primary: '30 99% 46%',
      'primary-foreground': '0 0% 100%',
      secondary: '30 99% 46%',
      'secondary-foreground': '0 0% 100%',
      accent: '30 99% 46%',
      'accent-foreground': '0 0% 100%',
      success: '80 61% 50%',
      'success-foreground': '210 8% 14%',
      warning: '40 97% 59%',
      'warning-foreground': '210 8% 14%',
      destructive: '357 96% 58%',
      'destructive-foreground': '0 0% 100%',
      info: '188 78% 41%',
      'info-foreground': '0 0% 100%',
      contrast: '235 16% 15%',
      'contrast-foreground': '255 0% 95%',
      border: '0 0% 80%',
      overlay: '0 0% 40%',
      muted: '0 0% 60%',
      shadow: '240 5.9% 10%',
    },
    // The app has no dark mode — mirror light values so dark-system users
    // still see the correct light design.
    dark: {
      background: '0 0% 100%',
      foreground: '0 0% 13%',
      primary: '30 99% 46%',
      'primary-foreground': '0 0% 100%',
      secondary: '30 99% 46%',
      'secondary-foreground': '0 0% 100%',
      accent: '30 99% 46%',
      'accent-foreground': '0 0% 100%',
      success: '80 61% 50%',
      'success-foreground': '210 8% 14%',
      warning: '40 97% 59%',
      'warning-foreground': '210 8% 14%',
      destructive: '357 96% 58%',
      'destructive-foreground': '0 0% 100%',
      info: '188 78% 41%',
      'info-foreground': '0 0% 100%',
      contrast: '235 16% 15%',
      'contrast-foreground': '255 0% 95%',
      border: '0 0% 80%',
      overlay: '0 0% 40%',
      muted: '0 0% 60%',
      shadow: '240 5.9% 10%',
    },
  },
};
